import { render, staticRenderFns } from "./CreateModel.vue?vue&type=template&id=7ba20912&scoped=true"
import script from "./CreateModel.vue?vue&type=script&lang=js"
export * from "./CreateModel.vue?vue&type=script&lang=js"
import style0 from "./CreateModel.vue?vue&type=style&index=0&id=7ba20912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba20912",
  null
  
)

export default component.exports